/**
 * Unmatched Invoices Tab Component
 * 
 * Wrapper for unmatched invoices management in the Bank Reconciliation page.
 */

import React from 'react';
import { Typography } from 'antd';
import UnmatchedInvoicesList from './UnmatchedInvoicesList';

const { Title } = Typography;

const UnmatchedInvoicesTab: React.FC = () => {
  return (
    <div>
      <Title level={4} style={{ marginBottom: 16 }}>
        Unmatched Invoices
      </Title>
      <UnmatchedInvoicesList />
    </div>
  );
};

export default UnmatchedInvoicesTab;
